import { render } from "./WarningDetail.vue?vue&type=template&id=9bbeeffa&scoped=true"
import script from "./WarningDetail.vue?vue&type=script&lang=js"
export * from "./WarningDetail.vue?vue&type=script&lang=js"

import "./WarningDetail.vue?vue&type=style&index=0&id=9bbeeffa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9bbeeffa"]])

export default __exports__